// extracted by mini-css-extract-plugin
export default {"text":"button_text__mEhpy","link":"button_link__OGIu6"};